import { MouseEventHandler, useState } from 'react';
import { Button, Popover, SVGMol, SVGMolSpace, TextArea } from '@moleculeone/ui';
import { Mol } from '@retro-ui/api-contract';
import { V4 } from '@moleculeone/utils';
import { Vector } from '@moleculeone/types';
import cx from 'classnames';

import { Space } from '../../hooks';
import { Selection } from '../Selection/Selection';

import cls from './DrawingSpace.module.css';

export const MENU = 'MENU';
export const ELEMENT = 'ELEMENT';
export const HOTKEYS = 'HOTKEYS';
export const FRAGMENT = 'FRAGMENT';
export const PICKER = 'PICKER';

interface DrawingSpaceProps extends Space {
  className?: string;
  onContextMenuOpen?: MouseEventHandler;
  onMolUpdate?: (mol: Mol) => void;
}

export function DrawingSpace(props: DrawingSpaceProps) {
  const {
    className,
    drawnMol,
    loop,
    viewport,
    svgPreview,
    onContextMenuOpen,
    onMouseEvent,
    locationAnalogPromptNodes,
  } = props;

  return (
    <SVGMolSpace
      className={cx(cls.editorSpace, className, {
        [cls.hasPreview]: svgPreview,
      })}
      onMouseEvent={onMouseEvent}
      onContextMenu={
        typeof onContextMenuOpen === 'function'
          ? event => {
              onContextMenuOpen(event);
            }
          : () => {}
      }
      viewport={viewport}
    >
      <SVGMol drawnMol={drawnMol} className={cls.mol} />
      <Selection points={loop} />
      {locationAnalogPromptNodes ?? null}
      {svgPreview && <SVGMol preview drawnMol={svgPreview} className={cls.previewMol} />}
    </SVGMolSpace>
  );
}
